import { signInWithProviderModalModule } from 'root/src/client/web/auth/descriptions/modules/signInWithProviderModalModule';
import { transformToCreatorModalModule, } from 'root/src/client/web/auth/descriptions/modules/transformToCreatorModalModule';
export const authModule = Object.assign(Object.assign({}, signInWithProviderModalModule), transformToCreatorModalModule);
